import React, { useEffect } from 'react';
import { Box, Flex, Text, Button } from '@chakra-ui/react';
import { AiOutlineLeft, AiOutlineClose, AiOutlineRight } from 'react-icons/ai';
import { RiHistoryFill } from 'react-icons/ri';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { IconWrapper } from 'shared/styled';

const list = [...Array(24).keys()].map((item) => ({ id: item }));

// TODO sab kaam chalaau
interface footerProps {
	historyHandler?: () => void;
	setHideFooter: (x: boolean) => void;
	refetch: () => void;
}

const Footer: React.FC<footerProps> = ({
	historyHandler,
	setHideFooter,
	refetch,
}) => {
	const apiTimeFromLocalstorage = JSON.parse(
		localStorage.getItem('apiTime') ?? 'null'
	);

	const currentDate = apiTimeFromLocalstorage
		? new Date(apiTimeFromLocalstorage)
		: new Date();

	const [startDate, setStartDate] = React.useState(currentDate.getTime());

	const [hours, setHours] = React.useState(
		apiTimeFromLocalstorage ? currentDate.getHours() - 1 : 0
	);

	useEffect(() => {
		async function updateLocalstorage() {
			await localStorage.setItem('apiTime', JSON.stringify(startDate));
			refetch();
		}
		updateLocalstorage();
		//eslint-disable-next-line
	}, [startDate]);

	const nextDate: () => void = () => {
		const date = new Date(startDate);
		date.setDate(date.getDate() + 1);
		date.setHours(hours + 1);
		date.setMinutes(0);
		date.setSeconds(0);

		setStartDate(date.getTime());
		window.location.reload();
	};

	const prevDate: () => void = () => {
		let date = new Date(startDate);
		date.setDate(date.getDate() - 1);
		date.setHours(hours + 1);
		date.setMinutes(0);
		date.setSeconds(0);

		setStartDate(date.getTime());
		window.location.reload();
	};

	return (
		<Box
			display='flex'
			p={5}
			bg='white'
			w='98vw'
			h={[50, 50, 50, 30]}
			alignItems='center'
			justifyContent='space-between'
		>
			<Box display='flex' flexDirection='row' alignItems='center'>
				<IconWrapper onClick={historyHandler}>
					<RiHistoryFill size={20} />
				</IconWrapper>
				<Text ml={3} fontSize='md'>
					History
				</Text>

				<Box display='flex' flexDirection='row' alignItems='center'>
					<IconWrapper onClick={prevDate}>
						<AiOutlineLeft size={16} />
					</IconWrapper>
					<Box
						width='90px'
						color=' blue'
						outline='none'
						cursor='pointer'
						overflow='hidden'
					>
						<DatePicker
							wrapperClassName='date-picker'
							selected={new Date(startDate)}
							dateFormat='MMM dd, yyyy'
							popperPlacement='top'
							onChange={(date: Date) => {
								date.setHours(hours + 1);
								date.setMinutes(0);
								date.setSeconds(0);
								setStartDate(date.getTime());
								window.location.reload();
							}}
						/>
					</Box>
					<IconWrapper onClick={nextDate}>
						<AiOutlineRight size={20} />
					</IconWrapper>
				</Box>
			</Box>

			<Text
				color='primary'
				cursor='pointer'
				onClick={() => {
					const date = new Date();
					setStartDate(date.getTime());
					window.location.reload();
				}}
			>
				Today
			</Text>
			<Flex alignItems='center'>
				<Text fontSize='md' mr='2'>
					Time
				</Text>
				<Box justifySelf='center' display='flex' flexDir='row'>
					{list.map((item) => (
						<Button
							key={item.id}
							bg={hours === item.id ? 'blue' : 'white'}
							color={hours === item.id ? 'white' : 'blackAlpha.600'}
							_focus={{
								boxShadow: 'none',
								// color: 'white',
							}}
							size='xs'
							sx={{
								padding: 2,
								borderRadius: 'none',
								border: '1px light blue',
								borderWidth: 'thin',
								boxShadow: 'none',
								// color: 'blackAlpha.600',
							}}
							onClick={() => {
								const date = new Date(startDate);
								date.setHours(item.id + 1);
								date.setMinutes(0);
								date.setSeconds(0);

								setStartDate(date.getTime());
								setHours(item.id);
								window.location.reload();
							}}
						>
							<Text fontSize='md'>{item.id + 1}</Text>
						</Button>
					))}
				</Box>
				<IconWrapper
					onClick={() => {
						const date = new Date();
						localStorage.setItem('apiTime', JSON.stringify(date.getTime()));
						setStartDate(date.getTime());
						setHideFooter(true);
					}}
				>
					<AiOutlineClose size={20} />
				</IconWrapper>
			</Flex>
		</Box>
	);
};

export default Footer;
